import { Paper, Stack, Typography } from '@mui/material';
import { Suspense } from 'react';
import PipelineListData from '@/pages/common/Administrator/Pipeline/components/PipelineListData';
import LoadingState from '@/components/LoadingState';

const PipelinesHeader = () => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{ pb: 2 }}
  >
    <Stack spacing={0.25}>
      <Typography variant="h3">Pipelines</Typography>
      <Typography variant="body2" color="text.secondary">
        Review available analysis pipelines and their configuration templates.
      </Typography>
    </Stack>
  </Stack>
);

const PipelinesPage = () => (
  <Stack direction="column">
    <PipelinesHeader />
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Suspense fallback={<LoadingState label="Loading pipelines…" />}>
        <PipelineListData />
      </Suspense>
    </Paper>
  </Stack>
);

export default PipelinesPage;
